import useFetch from '@hooks/useFetch';

const useEducatorCuratedPlaylist = (
  authorID,
  options = { fallbackData: undefined }
) => {
  const key = `v1/curated_content/${authorID}/playlist/`;
  const { data, mutate, ...rest } = useFetch(
    key,
    {},
    { fallbackData: options.fallbackData }
  );

  const curatedPlaylistData = {
    hasCuratedPlaylistData: !!data?.results?.length,
    data: data?.results,
    metaData: data?.metaData ?? {}
  };
  return {
    key,
    curatedPlaylistData,
    mutate,
    ...rest
  };
};

export default useEducatorCuratedPlaylist;
